export default {"src":"/_next/static/media/profile-weakness.58bdd045.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};